<template>
    <!-- eslint-disable max-len -->
    <footer class="footer">
        <div class="footer_haut">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8 col-md-8">
                        <div class="region region-footer-haut-gauche">
                            <section id="block-edg-2016-base-menu-services-informations"
                                     class="block block-edg-2016-base clearfix">
                                <div class="item-list">
                                    <h3>Informations générales</h3>
                                    <ul class="nav">
                                        <li class="first last">
                                            <a
                                                    href="https://ge.ch/organisation/administration-fiscale-cantonale"
                                                    target="_blank">Administration fiscale cantonale
                                            </a>
                                        </li>

                                    </ul>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- FOOTER NOIR (MODIFICATIONS INTERDITES) -->
        <div class="footer_bas">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8 col-md-8 col-sm-8">
                        <div class="region region-footer-bas">
                            <section id="block-menu-block-1" class="block block-menu-block clearfix">
                                <div class="menu-block-wrapper menu-block-1 menu-name-menu-pied-de-page-fonce parent-mlid-0 menu-level-1">
                                    <ul class="menu nav">
                                        <li class="first leaf menu-mlid-1440">
                                            <a href="https://ge.ch/protection-donnees" target="_blank">
                                                Protection des données
                                            </a>
                                        </li>
                                        <li class="last leaf menu-mlid-1441">
                                            <a href="https://ge.ch/annuaireofficiel_public/welcome/" target="_blank">Annuaire</a>
                                        </li>
                                    </ul>
                                </div>
                            </section>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <span class="footer-logo">République et canton de Genève</span>
                    </div>
                </div>
            </div>
        </div>

    </footer>
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style scoped>

</style>
